import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";
import { EstateUserInfo } from "models/EstateUserInfo";

export enum Outcomes {
  attorney = "Attorney",
  accountant = "Accountant",
  financialAdvisor = "Financial advisor",
  probateClerk = "Probate clerk",
  realEstateAgent = "Real estate agent",
  insuranceAgent = "Insurance agent",
  somethingElse = "Something else",
}

export const AdvisoryPositionScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const { flow, activeEstate, setActiveEstate, user } = useAuthContext()
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (
    advisoryPosition: string,
    more?: string
  ): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    const estate = activeEstate || new Estate();

    if (estate.estateUserInfo) {
    } else {
      const estateUserInfo = new EstateUserInfo(undefined, user?.id, estate.id || undefined);
      estate.estateUserInfo = estateUserInfo;
    }

    estate.estateUserInfo.advisoryPosition = advisoryPosition;
    estate.estateUserInfo.advisoryPositionMore = more || undefined;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, advisoryPosition, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title="Do you serve the Estate as one of these advisory positions?">
      <RadioAndResponseForm
        initAnswer={activeEstate?.estateUserInfo?.advisoryPosition}
        initMoreAnswer={activeEstate?.estateUserInfo?.advisoryPositionMore}
        answerLabel="AdvisoryPosition"
        errorText="Please select an option to continue"
        options={[
          { value: Outcomes.attorney },
          { value: Outcomes.accountant },
          { value: Outcomes.financialAdvisor },
          { value: Outcomes.probateClerk },
          { value: Outcomes.realEstateAgent },
          { value: Outcomes.insuranceAgent },
          { value: Outcomes.somethingElse, followUp: "Tell us more" },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
